import {Message} from "./message";
import {AlertMessage} from "./alert-message";

export class ExternalCancel implements Message, AlertMessage {
  constructor(public orderId: number, public freighterId, public text?: string) {}

}